import { render, staticRenderFns } from "./ExpensesLinks.vue?vue&type=template&id=55f9fe56&scoped=true"
import script from "./ExpensesLinks.vue?vue&type=script&lang=js"
export * from "./ExpensesLinks.vue?vue&type=script&lang=js"
import style0 from "./ExpensesLinks.vue?vue&type=style&index=0&id=55f9fe56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9fe56",
  null
  
)

export default component.exports